require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-nithya-easwaran.json") })
        }
      }, "path---insights-nithya-easwaran");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-nithya-easwaran!./.cache/json/insights-nithya-easwaran.json
// module id = 1149
// module chunks = 231608221292675